import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import { ContentGroupCreateForm } from "./content-group-create-form";

class ContentGroupModal extends React.PureComponent {
  static get displayName() {
    return "ContentGroupModal";
  }

  static get propTypes() {
    return {
      content: PropTypes.array,
      createContentGroup: PropTypes.func,
      isVisible: PropTypes.bool,
      name: PropTypes.string,
      onCancel: PropTypes.func,
      userContents: PropTypes.array,
      updateContent: PropTypes.func,
      updateName: PropTypes.func,
    };
  }

  static get defaultProps() {
    return {
      content: [],
      name: "",
    };
  }

  constructor(props) {
    super(props);

    this._createContentGroup = this._createContentGroup.bind(this);
  }

  _createContentGroup() {
    const { createContentGroup, content, name } = this.props;
    createContentGroup({ content, name });
  }

  render() {
    const {
      content,
      isVisible,
      name,
      onCancel,
      updateContent,
      updateName,
      userContents,
    } = this.props;

    return (
      <Modal show={isVisible}>
        <Modal.Header>
          <Modal.Title>Create Media Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ContentGroupCreateForm
            contentGroupName={name}
            onChangeName={updateName}
            onUpdateContent={updateContent}
            selectedContent={content}
            userContents={userContents}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onCancel} variant="secondary">Cancel</Button>
          <Button variant="primary" onClick={this._createContentGroup}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export { ContentGroupModal };
